import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText, } from '@mui/material';
import { alpha, } from '@mui/material/styles';
import { useAppbar, } from '../../../hooks';
import CustomLink from '../../custom-link';

export default function CustomizedList({ pages, sx = [], ...props }) {
    const { drawerMenuClose, } = useAppbar();

    return (
        <List
            disablePadding
            sx={[
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...props}>
            {
                pages.map((page, index) => {
                    return (
                        <ListItem
                            onClick={drawerMenuClose}
                            onKeyDown={drawerMenuClose}
                            disablePadding
                            disableGutters
                            key={page.name}
                            sx={{
                                mb: (pages.length - 1 === index) ? 0 : 0.5,
                                '&:hover': {
                                    bgcolor: 'transparent',
                                    '.MuiSvgIcon-root, .MuiListItemText-root': {
                                        color: 'secondary.main',
                                    },
                                },
                                '&:active': {
                                    bgcolor: (theme) => alpha(
                                        theme.palette.text.secondary,
                                        theme.palette.action.selectedOpacity,
                                    ),
                                },
                            }}>
                            <CustomLink
                                to={page.link}
                                variant='btn'
                                sx={{
                                    border: 0,
                                    borderRadius: 0,
                                    color: 'text.primary',
                                    fontSize: 14,
                                    p: 0,
                                    width: '100%',
                                }}>
                                <ListItemIcon sx={{
                                    minWidth: 'auto',
                                    mt: '-2px',
                                    mr: 1.5,
                                }}>
                                    <page.icon sx={{
                                        color: 'text.primary',
                                        fontSize: 20, }} />
                                </ListItemIcon>
                                <ListItemText disableTypography>{page.name}</ListItemText>
                            </CustomLink>
                        </ListItem>
                    );
                })
            }
        </List>
    );
};